import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import ReactGA from 'react-ga';

import ScoreForm from './ScoreFormLayout';

export default class ScoreFormModal extends Component {
  static propTypes = {
    trigger: PropTypes.element,
  };

  static defaultProps = {
    trigger: <Button>Show Modal</Button>,
  };

  state = {
    modalOpen: false,
  };

  closeModal = () => {
    try {
      ReactGA.event({
        category: 'EXAM_SCORE',
        action: 'Modal close',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    this.setState(prevState => ({ modalOpen: false }));
  };

  openModal = () => {
    try {
      ReactGA.event({
        category: 'EXAM_SCORE',
        action: 'Modal open',
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    this.setState(prevState => ({ modalOpen: true }));
  };

  renderTrigger = () => {
    return React.cloneElement(this.props.trigger, { onClick: this.openModal });
  };

  render() {
    return (
      <Modal
        className={'scrolling'}
        trigger={this.renderTrigger()}
        dimmer="inverted"
        open={this.state.modalOpen}
      >
        <Modal.Content>
          <ScoreForm showClose onClose={this.closeModal} />
        </Modal.Content>
      </Modal>
    );
  }
}
